import axios from 'axios'

/**
 * Daftarkan (upsert) token FCM perangkat ini ke akun yang sedang login.
 * BE meng-upsert berdasarkan `token`, jadi aman dipanggil berulang (app start,
 * token berganti, retry); token milik akun lain di perangkat yang sama otomatis
 * pindah ke akun yang login.
 * @param {object} data - Payload registrasi.
 * @param {string} data.token - Token FCM (maks 512 karakter).
 * @param {"android"|"ios"|"web"} data.platform - Platform perangkat.
 * @param {string} [data.app_version] - Versi aplikasi (maks 32 karakter).
 * @returns {Promise} Response axios.
 */
export const registerPushDevice = (data) => {
  return axios.post('/finance/pushNotifications/devices', data, {
    // Registrasi berjalan di latar belakang tanpa aksi user; kegagalannya
    // diulang di app start berikutnya, jadi jangan munculkan toast error global.
    skipErrorNotification: true,
  })
}
